import React from 'react';
import { render } from '@wordpress/element';
import App from './backend/components/App';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('bpsfw_admin_app');
  if (root) render(<App />, root);
});
